/**
 * Plan label + one-line note for the post-verify Welcome screen.
 * @param {string|undefined} tier  server effective tier (free|lite|pro|lifetime_lite|lifetime_pro)
 * @param {number|null} daysRemaining  desktop trial days left (getTrialDaysRemaining())
 */
const PAID = {
  pro: 'Scrivar Pro',
  lifetime_pro: 'Scrivar Pro',
  lite: 'Scrivar Lite',
  lifetime_lite: 'Scrivar Lite',
};

/**
 * True when the effective tier is an actual paid license (subscription OR a
 * registered lifetime code) — i.e. NOT free and NOT trial-only. Used to hide
 * the "Have an activation code?" prompt for users who are already licensed:
 * once a code is registered (or a plan is paid), asking for a code again is
 * confusing.
 * @param {string|undefined} tier
 */
export function isPaidTier(tier) {
  return Boolean(PAID[tier]);
}

export function planSummary(tier, daysRemaining) {
  if (PAID[tier]) {
    const isPro = tier === 'pro' || tier === 'lifetime_pro';
    return { plan: PAID[tier], note: isPro ? 'All Pro tools are unlocked.' : 'Your Lite tools are ready.' };
  }
  if (typeof daysRemaining === 'number' && daysRemaining > 0) {
    return { plan: 'Free trial', note: `${daysRemaining} day${daysRemaining === 1 ? '' : 's'} of full Pro features.` };
  }
  return { plan: 'Free', note: 'Get a lifetime license anytime to unlock every tool.' };
}
